import React, { Fragment, useEffect } from 'react';

import { Link } from 'react-router-dom';
import queryString from 'query-string';

import { WelcomeHeader } from '../../../WelcomeHeader';
import style from './Welcome.module.css';
import {
  SIGNUP_URL,
  ROUTE_LOGIN,
} from '../../../../constants';
import {
  withHistory,
  WithHistoryInjectedProps,
} from '../../../../hocs';

export type WagWelcomeProps = WithHistoryInjectedProps;

const WagWelcome = ({
  history: {
    location: {
      search,
    },
    push,
  },
}: WagWelcomeProps) => {
  const signupUrl = queryString.stringifyUrl({
    url: SIGNUP_URL,
    query: queryString.parse(search),
  });

  useEffect(() => {
    // Redirect to login and pass the query strings
    push({
      path: ROUTE_LOGIN,
      search: queryString.stringify(queryString.parse(search)),
      retainQueryString: false,
    });
  }, [push, search]);

  return (
    <Fragment>
      <WelcomeHeader />
      <div className={style.welcomeContainer}>
        <div className={style.row}>
          <div className={style.column}>
            <Link to={signupUrl}>
              <button
                type="button"
                className="btn btn-primary btn-block mb-2 mt-2"
                data-testid="signup-link"
              >
                  Sign Up with Email
              </button>
            </Link>

            <Link
              to="/login"
              data-testid="login-link"
            >
              Log In with Email
            </Link>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const WagWelcomeWithHistory = withHistory(WagWelcome);
export {
  WagWelcomeWithHistory as WagWelcome,
};
